import React from "react";
import SessionStore from "../../stores/SessionStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import {Route} from "react-router-dom";
import PublicWrapper from "../wrappers/PublicWrapper";
import PropTypes from "prop-types";
import PrivateWrapperContainer from "../wrappers/PrivateWrapperContainer";

const ContextualRoute = ({publicComponent: PublicComponent, privateComponent: PrivateComponent, appNavigator, ...rest}) => {

    class ContextualRedirectWrapper extends React.Component {

        static propTypes = {
            usesDefaultFooter: PropTypes.bool.isRequired
        };

        static defaultProps = {
            usesDefaultFooter: true
        };

        constructor(props) {
            super(props);
            this.state = {
                "sessionState": SessionStore.getState()
            };
        }

        componentDidMount() {
            this.sessionStoreSubscriber =
                EventPublisher.subscribe(StoreUpdateEvents.SESSION_STORE_UPDATED, this.handleStoreUpdate);
        }

        componentWillUnmount() {
            EventPublisher.unsubscribe(this.sessionStoreSubscriber);
        }

        handleStoreUpdate = (topic, data) => {
            this.setState({
                "sessionState": SessionStore.getState()
            });
        };

        render() {
            if (this.state.sessionState.isAuthenticated()) {
                return (
                    <PrivateWrapperContainer usesDefaultFooter={this.props.usesDefaultFooter}>
                        <PrivateComponent appNavigator={appNavigator} {...this.props}/>
                    </PrivateWrapperContainer>
                );
            } else {
                return (
                    <PublicWrapper usesDefaultFooter={this.props.usesDefaultFooter}>
                        <PublicComponent appNavigator={appNavigator} {...this.props}/>
                    </PublicWrapper>
                );
            }
        }
    }
    return (<Route {...rest} render={(routeProps) => <ContextualRedirectWrapper {...routeProps} {...rest}/>}/>);
};

export default ContextualRoute;